import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';

function LineupsTemplate({lineup, subs}) {

    const [keepers, setKeepers] = useState([])
    const [defenders, setDefenders] = useState([]);
    const [midfielders, setMidfielders] = useState([]);
    const [attackers, setAttackers] = useState([])

    const [hasPositions, setHasPositions] = useState(false)

    useEffect(() => {
        if (lineup) {
            
            if (lineup[0]?.pos) {
                setHasPositions(true)

                const  keepers = lineup.filter(player => {
                    return player.pos === "G"
                })
                setKeepers(keepers)
                const  defenders = lineup.filter(player => {
                    return player.pos === "D"
                })
                setDefenders(defenders)
                const midfielders = lineup.filter(player => {
                    return player.pos === "M"
                })
                setMidfielders(midfielders)
                const attackers = lineup.filter(player => {
                    return player.pos === "F"
                })
                setAttackers(attackers)
            }
            

        }

    }, [lineup])

    return (

        <React.Fragment>
            <div className="card card-header my-4 font-weight-bold">Starting XI</div>
            <React.Fragment>
                {!hasPositions && lineup?.map((player, index) => {
                    return (
                        <div key={index} className="">
                            <div className="card p-3">
                                <Link to={`/players-api/${player.player_id}`}>{player.pos} {player.player}</Link>
                            </div>
                        </div>
                    )
                })}
            </React.Fragment>
            {hasPositions && (
                <React.Fragment>
           {keepers.map((player, index) => {
                return (
                    <div key={index} className="">
                        <div className="card p-3">
                            <Link to={`/players-api/${player.player_id}`}>{player.pos} {player.player}</Link>
                        </div>
                    </div>
                )
            })}
            <br />
            {defenders.map((player, index) => {
                return (
                    <div key={index} className="">
                        <div className="card p-3">
                            <Link to={`/players-api/${player.player_id}`}>{player.pos} {player.player}</Link>
                        </div>
                    </div>
                )
            })}
            <br />
            {midfielders && midfielders.map((player, index) => {
                return (
                    <div key={index} className="">
                        <div className="card p-3">
                            <Link to={`/players-api/${player.player_id}`}>{player.pos} {player.player}</Link>
                        </div>
                    </div>
                )
            })}
            <br />
            {attackers && attackers.map((player, index) => {
                return (
                    <div key={index} className="">
                        <div className="card p-3">
                            <Link to={`/players-api/${player.player_id}`}>{player.pos} {player.player}</Link>
                        </div>
                    </div>
                )
            })}
                </React.Fragment>
            )}
 
            
            <div className="card card-header my-4 font-weight-bold">Substitutes</div>

            {subs && subs.map((player, index) => {
                return (
                    <div key={index} className="">
                        <div className="card p-3">
                            <Link to={`/players-api/${player.player_id}`}>{player.pos} {player.player}</Link>
                        </div>
                    </div>
                )
            })}

        </React.Fragment>

    )

}
export default LineupsTemplate